<template>
  <div class="content">
      <div class="pt0">
            <!-- 标题检索区 --> 
            <div class="back-color-fff">
                  <div class="h60">
                          <div class="t-left line-h60 fl" :style="selectWidth">
                                    <div class="fl ml15 font-S20">{{pageName}}</div>
                                    <!-- <el-select v-model="pageGuid" placeholder="选择页面"  filterable class="fl font-S20 font-W" @change="changeReport(pageGuid)">
                                          <el-option
                                                v-for="item in reportPageData"
                                                :key="item.guid"
                                                :label="item.pageName"
                                                :value="item.guid">
                                          </el-option>
                                    </el-select> -->
                          </div>
                          <a class="fr" :href="hrefPath" target="_blank"><div class="new-c-kou">新窗口打开</div></a>
                          <div class="fr btn-top-sty mr15 mt14">
                              <el-button size="medium" type="info" @click="seachQueryAll()">查询</el-button>
                              <el-button size="medium" type="info" @click="empty">清空</el-button> 
                              <!-- <el-button size="medium" type="danger" @click="returnPath">返回</el-button> 
                              <el-button size="medium" type="danger" @click="toHome">返回首页</el-button> --> 
                         </div>
                  </div>
                  <div class="h50" v-if="outParamList != null && outParamList.length > 0">
                        <div class="fl w320" v-for="(pa,index) in outParamList" v-if="outParamList != null && outParamList.length > 0"  @click="getParamblur(index)">
                              <div class="search-area-div">{{pa.name}}：</div>
                              <div><el-input type="text" v-model="pa.param" :id='index' class="ipt-sty font-S14 border1px" clearable></el-input></div>
                        </div>   
                 </div>
            </div> 
            <!-- 标题检索区  end -->
            <!-- 维度查询1区 -->
            <div class="report-top" v-if="pageLayoutListSh && dimensionZoneTopList != null">
                    <div class="report-title">
                          <h4 class="fl">维度区域</h4> 
                    </div> 
                    <datepickerLook ref="arrive" :inline="false" v-if="pageLayoutListSh && dimensionZoneTopList != null" @getResult="getResults" :yearData.sync="yearData" :quarterData.sync="quarterData" :monthData.sync="monthData" class="h90" ></datepickerLook> 
            </div>
             <!-- @getYearmonths="getYearmonth"  -->
            <!-- 维度查询1区 end-->
            <div class="report-center">
                   <div  class="report-center-left fl mb40" v-if="pageLayoutListLeftSh"> 
                            <div class="report-center-left-list">  
                                <div class="mb10 back-color-fff" v-for="(re,idn1) in dimensionZoneLeftList"  v-show="pageLayoutListLeftSh">
                                      <div class="report-title">
                                            <h4 class="fl">{{re.dimensionName}} </h4>
                                      </div> 
                                      <div class="btn-list"  v-if="re && re.resultList != null && re.resultList.length >0"> 
                                            <div class="btn" :class="le.showSh == true ?' seleds':' '"  v-for="(le,idn2) in re.resultList" @click="getDownList(idn1,idn2,re.getShDown,re.dimensionGuid,le[re.useFieldList[0]])">{{le[re.useFieldList[0]]}}</div>
                                      </div> 
                                </div>
                            </div>
                   </div>
                   <div  class="report-center-right fr" :style="widthleft"> 
                          <div v-if="rankingListSh"> 
                                  <div class="back-color-fff mt10 pb14">
                                        <div class="report-title mb15">
                                              <p></p><h4 class="fl ml10">排名区</h4> 
                                        </div>   
                                        <div class="margin40px mt10 mb10 h66">  
                                          <el-slider v-model="page.pageSize" :max="rankingData.maxValue" :marks="marks"></el-slider>
                                         </div>
                                  </div>
                          </div>

                          <div v-if="aggregateListSh && summaryResults != null && summaryResults.length > 0"> 
                                  <div class="back-color-fff mt10 pb14">
                                        <div class="report-title mb10">
                                              <p></p><h4 class="fl ml10">汇总数展示区</h4>
                                        </div> 
                                        <div class="h187">
                                              <div class="summary-center-sty" :style="width" v-for="su in summaryResults" v-if="su.sum != null && su.sum != ''">
                                                    <div class="summary-center-all">
                                                            <div class="summary-center-top-sty">{{su.aggregateDataName}}</div>
                                                            <div class="summary-center-bottom-sty">{{su.sum  | numDigit | numFmt}}<label>{{su.valueType | summaryResultValueType}}</label></div>
                                                    </div>
                                                      
                                              </div>
                                              <div class="summary-center-sty" :style="width" v-else>
                                                      <img class="t-center mt100" src="../../assets/images/roll.gif" width="40">
                                              </div>
                                        </div>
                                  </div>
                          </div>

                          <div v-if="analysisChartListSh && barCharList != null && barCharList.length > 0">  
                                 <!--  -->
                              <div class="mt10">
                                    <div class="report-title back-color-fff">
                                          <p></p><h4 class="fl ml8">图表区</h4> 
                                    </div> 
                                    <div> 
                                          <bar ref="bar" :barCharLists.sync="barCharList"></bar> 
                                    </div>
                              </div>
                        </div>

                          <div class="mb40" v-if="gridAllListSh && tableAllResult !=null && tableAllResult.length > 0"> 
                              <div class="back-color-fff mt10 pb14">
                                    <div class="report-title mb15">
                                          <p></p><h4 class="fl ml8">表格区</h4> 
                                    </div>  
                                    <div class="p16 pt0">
                                    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                                          <template v-for="ta in tableAllResult">
                                          <el-tab-pane :label="ta.title" :name="ta.title" :key="ta.title">  
                                                <el-button size="medium" class="fr mb15" type="info" @click="exportDatasetReport">导出</el-button>
                                                <el-table style="width: 100%" border :data="ta.tableData" v-if="ta.tableData != null && ta.tableData.length > 0">
                                                      <template v-for="(item,ind) in ta.tableHead">
                                                            <el-table-column :prop="item" :label="item" v-if="item.indexOf('元') != -1 || item.indexOf('%') != -1" :key="ind" header-align="center" sortable align="right" show-overflow-tooltip>
                                                            </el-table-column> 
                                                            <el-table-column :prop="item" :label="item" v-if="item.indexOf('元') == -1 && item.indexOf('%') == -1" :key="ind" header-align="center" sortable align="center" show-overflow-tooltip> 
                                                            </el-table-column> 
                                                      </template> 
                                                      <el-table-column label="操作" header-align="center" align="center" v-if="ta.drillFieldList != null">
                                                            <template slot-scope="scope">
                                                                  <a class="txt-color" @click="toDetail(ta,scope.row)">详情</a>
                                                            </template>
                                                      </el-table-column>
                                                </el-table>
                                                <div v-if="ta.tableData.length == 0 || ta.tableData == null">
                                                      <img class="t-center" src="../../assets/images/roll.gif" width="40">
                                                </div>
                                          </el-tab-pane>
                                          </template>
                                          <el-pagination
                                                class="pt pb back-color-fff"
                                                background
                                                @size-change="handleSizeChange"
                                                @current-change="handleCurrentChange"
                                                :page-sizes="[10, 50, 100]"
                                                :current-page="page.pageIndex"
                                                :page-size="page.pageSize"
                                                layout="total, sizes, prev, pager, next"
                                                :total="page.totalRows">
                                          </el-pagination>
                                    </el-tabs> 
                                    </div> 
                              </div>
                        </div>

                        

                   </div>
            </div>
      </div>  
  </div>
</template>

<script> 
import datepickerLook from '../../components/datepickerLook.vue'; //时间组件
import bar from '../../components/bar.vue'; //时间组件
export default {
    components: { 
    datepickerLook,
    bar,
  },
  data() {
    return {     
      barCharList:[
            // {id:'id1',title:'终端数统计',data:[120, 200, 150, 80, 70, 110, 130],analysisType:'bar'},
            // {id:'id2',title:'终端数统计',data:[10, 20, 20, 20, 20, 20, 20],analysisType:'pie'},
            // {id:'id3',title:'终端数统计',data:[10, 20, 20, 20, 20, 20, 20],analysisType:'barandline'},
            // {id:'id4',title:'终端数统计',data:[10, 20, 20, 20, 20, 20, 20],analysisType:'barmore'},
      ],
      winHeight: window.innerHeight,
      height: {
        height: '',
      },
      pageName:'',
      pageUrl:'',
      pageGuid:'',
      oldPageName:'',
      oldPageUrl:'',
      dimension1:'1', //维度一区显示隐藏
      dimension2:'1',
      dimension3:'1',
      dimension4:'1',
      timeList: [],
      dimensionZoneTopList:[],
      pageLayoutListSh:false,
      pageLayoutListLeftSh:false,
      // dataSetListSh:false,
      aggregateListSh:false,
      analysisChartListSh:false,
      gridAllListSh:false,
      yearData:{
        dimensionGuid:'',
        getOnclick:'',
        list:[]
      },
      dataSetList: [],
      aggregateList:[],
      gridAllList:[],
      rankingData:{},
      quarterData:[],
      monthData:[],
      allData:[],
      formAreaList:[],
      formAreaListSh:true,
      dimensionZoneLeftList:[],
      das:'',
      ranking:0,
      rankingListSh:false,
      marks: {
          0:'0',
          200:'200',
        },
      moList:[],
      dataListAll:[],
      chartDatasetResult:[],
      tableAllResult:[{
            datasetGuid:'',
            title:'',
            tableHead:'',
            drillFieldList:[],
            tableData:[], 
      }],
      page:{
            pageIndex:1,
            pageSize:10,
            totalPage:0,
            totalRows:0, 
            datasetGuid:'',
            pageLayoutGuid:'',
            paramData:'',
      }, 
      activeName:'',
      gridList:'',
      summaryAll:[],
      summaryResult:[],
      summaryResults:[],
      outParamList:[], 
      width: {
        width: '',
      },
      widthleft: {
        width: '',
      },
      selectWidth: {
        width: '',
      },
      reportPageData:[],
      hrefPath:'',
    };
  },
  created() {
      let self = this;
      console.log(window.location.href);
      console.log(self.$route.path);
      // self.hrefPath = window.location.href;
      self.getReportPage();
      //  if(localStorage.getItem("dimensionZoneTopList")){
      //        this.pageLayoutListSh = true;
      //  }
      //  if(localStorage.getItem("dimensionZoneLeftList")){
      //        this.pageLayoutListLeftSh = true;
      //  }

  },   
  watch: {  
         "$route": "getReportPage",
    dimension1(val){
          // console.log(val);
          this.updatePageLayouthide();
    },
    dimension2(val){
          // console.log(val);
          this.updatePageLayoutLefthide();
    },
    dimension3(val){
          // console.log(val);
          this.updatePageLayoutCenterAggregatehide();
    },
    dimension4(val){
          // console.log(val);
          this.updatePageLayoutCenterrRankinghide();
    },
  },
  mounted(){    
      window.onresize = () => { 
      return (() => { 
      this.winHeight = window.innerHeight 
          })
      } 
    this.height.height=this.winHeight-130+'px';
  }, 
  methods: {
        getParamblur(index){
              document.getElementById(index).focus(); 
        },
        getReportPage() {   
                  let self = this;    
                  let route = self.$route.path;
                  // console.log('123456',localStorage.getItem("reportMenu"));
                  self.api.postJson(`/${serverConfig.msReportConfigService}/reportpage/get`,{'pageIndex':1,'pageSize':'-1','publishState':'Y'}).then(res=>{  
                        if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                              self.reportPageData = res.data.data.records;
                              self.reportPageData.forEach(function(item) { 
                                     if(route == item.pageUrl){
                                          self.selectWidth.width = item.pageName.length * 32+'px';
                                          let items = {
                                                pageGuid:item.guid,
                                                pageName:item.pageName,
                                                pageUrl:item.pageUrl
                                          }
                                          self.pageName = item.pageName;
                                          localStorage.setItem('pageinfo',JSON.stringify(items)); 
                                          self.pageGuid = item.guid;
                                          self.getPageLayoutData(item.guid); 
                                     }
                              }); 
                        }else {
                        self.$message.error(res.data.msg);
                        } 
                  }) 
        }, 
        //获取页面布局
        getPageLayoutData(guid) {
              let self = this;   
                // self.pageGuid = JSON.parse(localStorage.getItem("pageinfo")).pageGuid; //获取到报表页面guid
                self.api.get(`/${serverConfig.msReportConfigService}/reportpage/get-page-layout?reportPageGuid=`+guid).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                               localStorage.setItem('pageLayoutList',JSON.stringify(res.data.data));
                               self.getDimensionZoneData();
                       }else {
                        self.$message.error(res.data.msg);
                       } 
                }) 
        },
        changeReport(pageGuid){
                  let self = this; 
                  self.reportPageData.forEach(function(item) { 
                  if(pageGuid == item.guid){ 
                        self.selectWidth.width = item.pageName.length * 32+'px';
                        let items = {
                              pageGuid:item.guid,
                              pageName:item.pageName,
                              pageUrl:item.pageUrl
                        }
                        localStorage.setItem('pageinfo',JSON.stringify(items)); 
                        self.getPageLayoutData(pageGuid);
                  }
            }); 
        },
        returnPath(){
              this.$router.push({path: "/addReport",query:{ productGuid:this.$route.query.productGuid}});
        },
        toHome(){
              this.$router.push({path: "/reportManagement",query:{ productGuid:this.$route.query.productGuid}});
        }, 
         // 获取获取页面各区域布局 明细
        getDimensionZoneData() {
                let self = this;
                let pageLayoutGuid = '';
                self.pageLayoutListSh = false;
                self.pageLayoutListLeftSh = false;
                self.aggregateListSh = false;
                self.analysisChartListSh = false;
                self.gridAllListSh = false;
                let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList")); 
                if(pageInfoList !=null && pageInfoList.length > 0){
                      pageInfoList.forEach((i)=>{
                            if(i.zoneLocation == 'TOP' && i.zoneType == '1'){
                                    if(i.isHide == "N"){
                                          self.pageLayoutListSh = false;
                                    }else{
                                          setTimeout(function(){
                                                self.pageLayoutListSh = true;
                                          },1000); 
                                    }
                                    pageLayoutGuid = i.guid;   //获取页面布局   维度一区的guid
                                    self.getTopData(pageLayoutGuid);
                            }else if(i.zoneLocation == 'LEFT' && i.zoneType == '1'){
                                    if(i.isHide == "N"){
                                          self.pageLayoutListLeftSh = false;
                                    }else{
                                          self.pageLayoutListLeftSh = true;
                                    }
                                    pageLayoutGuid = i.guid;   //获取页面布局   维度一区的guid 
                                    self.getLeftData(pageLayoutGuid);
                            }else if(i.zoneLocation == 'CENTER' && i.zoneType == '2'){
                                    if(i.isHide == "N"){
                                          self.rankingListSh = false;
                                    }else{
                                          self.rankingListSh = true;
                                    }
                                    pageLayoutGuid = i.guid;   //获取页面布局   汇总的guid 
                                    self.getRankingDataList(pageLayoutGuid);
                            }else if(i.zoneLocation == 'CENTER' && i.zoneType == '3'){
                                    if(i.isHide == "N"){
                                          self.aggregateListSh = false;
                                    }else{
                                          self.aggregateListSh = true;
                                    }
                            }else if(i.zoneLocation == 'CENTER' && i.zoneType == '4'){
                                    if(i.isHide == "N"){
                                          self.analysisChartListSh = false;
                                    }else{
                                          self.analysisChartListSh = true;
                                    }
                            }else if(i.zoneLocation == 'CENTER' && i.zoneType == '5'){
                                    if(i.isHide == "N"){
                                          self.gridAllListSh = false;
                                    }else{
                                          self.gridAllListSh = true;
                                    } 
                            }
                            if(!self.pageLayoutListLeftSh){
                                  self.widthleft.width = '100%';
                            }else{
                                  self.widthleft.width = '79.5%';
                            }
                      })
                      self.queryAll();
                } 
        },
        getTopData(pageLayoutGuid){
              let self = this;
              self.api.get(`/${serverConfig.msReportConfigService}/dimension-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                        //   self.pageLayoutListSh = true;
                          self.dimensionZoneTopList = res.data.data;
                          if(self.dimensionZoneTopList != null && self.dimensionZoneTopList.length > 0){
                                     self.dimensionZoneTopList.forEach((i,index)=>{
                                      // 获取维度结果
                                    self.getDimensionTopResult(index,i.dimensionGuid,null); 
                              })
                          } 
                        //   setTimeout(function(){
                        //            self.getYearmonth();
                        //   },1);
                          // self.yearData = [{date:'2019年',type:false},{date:'2020年',type:false},{date:'2021年',type:false}];
                     }else {
                      self.$message.error(res.data.msg);
                     } 
                }) 
        },
        //获取结果 获取维度一区
        getDimensionTopResult(index,dimensionGuid,paramData){
          let self = this;
          self.api.postJson(`/${serverConfig.msReportConfigService}/dimension-config/get-dimension-result?dimensionGuid=`+dimensionGuid,{'paramData':paramData}).then(res=>{
                         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                              self.dimensionZoneTopList[index].resultList = res.data.data;
                              localStorage.setItem('dimensionZoneTopList',JSON.stringify(self.dimensionZoneTopList));
                         }else {
                          self.$message.error(res.data.msg);
                         } 
                  }) 
        },
        // 获取维度 左边
        getLeftData(pageLayoutGuid){
              let self = this;
              let linkageDimensionGuidList = [];
              self.api.get(`/${serverConfig.msReportConfigService}/dimension-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                        //   self.pageLayoutListLeftSh = true;
                          self.dimensionZoneLeftList = res.data.data;
                          //汇总上级guid
                          if(self.dimensionZoneLeftList != null && self.dimensionZoneLeftList.length > 0){
                                self.dimensionZoneLeftList.forEach((i)=>{ 
                                     if(i.dimensionLinkageVOS != null && i.dimensionLinkageVOS.length > 0){ 
                                            i.dimensionLinkageVOS.forEach((j)=>{
                                              linkageDimensionGuidList.push(j.linkageDimensionGuid);
                                            })
                                     }  
                              })
                          }
                          //关联上级guid
                          if(self.dimensionZoneLeftList != null && self.dimensionZoneLeftList.length > 0){
                                self.dimensionZoneLeftList.forEach((z,index)=>{  
                                     if(linkageDimensionGuidList != null && linkageDimensionGuidList.length > 0){
                                            linkageDimensionGuidList.forEach((s)=>{
                                                  if(z.dimensionGuid == s){ 
                                                          // console.log(z.dimensionGuid,s);
                                                          self.dimensionZoneLeftList[index].getShDown = true;
                                                      //     self.dimensionZoneLeftList[index].showSh = false;
                                                  }
                                            })
                                     }
                                    // 获取维度二区结果
                                    self.getDimensionLeftResult(index,z.dimensionGuid,null);
                              })
                          } 
                     }else {
                      self.$message.error(res.data.msg);
                     } 
                }) 
        },
        //获取结果 获取维度 左边
        getDimensionLeftResult(index,dimensionGuid,paramData){
          let self = this;
          self.api.postJson(`/${serverConfig.msReportConfigService}/dimension-config/get-dimension-result?dimensionGuid=`+dimensionGuid,{'paramData':paramData}).then(res=>{
                         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                              if(self.dimensionZoneLeftList != null && self.dimensionZoneLeftList.length > 0){
                                  self.dimensionZoneLeftList.forEach((m)=>{  
                                          if(m.useFieldList != null && m.useFieldList.length > 0){
                                                m.useFieldList.forEach((n)=>{
                                                  self.dimensionZoneLeftList[index].resultList = [];
                                                  self.dimensionZoneLeftList[index].resultLists = [];
                                                            if(res.data.data != null && res.data.data.length > 0){ 
                                                                       res.data.data.forEach((o)=>{
                                                                                      o.showSh = false;
                                                                                      self.dimensionZoneLeftList[index].resultList.push(o);
                                                                                      self.dimensionZoneLeftList[index].resultLists.push(o);
                                                                       })
                                                            }
                                                })
                                          }  
                                  })  
                           }
                              
                              localStorage.setItem('dimensionZoneLeftList',JSON.stringify(self.dimensionZoneLeftList));
                              self.dimensionZoneLeftList = [];
                              let dimensionZoneLeftList = JSON.parse(localStorage.getItem("dimensionZoneLeftList")); 
                              self.dimensionZoneLeftList = dimensionZoneLeftList;
                         }else {
                          self.$message.error(res.data.msg);
                         } 
                  }) 
        },
        getDownList(idn1,idn2,sh,dimensionGuid,da){
            let self = this;
            let parentList = [];
            if(self.dimensionZoneLeftList[idn1].resultList[idn2].showSh){
                  self.dimensionZoneLeftList[idn1].resultList[idn2].showSh = false;
            }else{
                  self.dimensionZoneLeftList[idn1].resultList[idn2].showSh = true;
            }
            console.log(idn1,idn2);
            localStorage.setItem('dimensionZoneLeftList',JSON.stringify(self.dimensionZoneLeftList)); 
            // if(sh && self.dimensionZoneLeftList[idn1].resultList[idn2].showSh){ 
                  let dimensionZoneLeftList = JSON.parse(localStorage.getItem("dimensionZoneLeftList")); 
                  if(dimensionZoneLeftList != null && dimensionZoneLeftList.length > 0){
                        dimensionZoneLeftList.forEach((m)=>{
                                if(m.dimensionLinkageVOS != null && m.dimensionLinkageVOS.length > 0){  
                                        m.dimensionLinkageVOS.forEach((n)=>{
                                              if(self.dimensionZoneLeftList[idn1].resultList != null && self.dimensionZoneLeftList[idn1].resultList != ''){
                                                      self.dimensionZoneLeftList[idn1].resultList.forEach((q)=>{
                                                            if(q.showSh){
                                                                  parentList.push(q[n.fieldName]);
                                                            }
                                                      })
                                                }
                                                console.log(parentList); 
                                              if(n.linkageDimensionGuid == dimensionGuid){
                                                    m.resultList = [];
                                                    if(parentList != null && parentList != ''){ 
                                                          parentList.forEach((w)=>{
                                                                  m.resultLists.forEach((p)=>{
                                                                        // console.log(p[n.fieldName],w); 
                                                                        if(p[n.fieldName] == w){ 
                                                                              m.resultList.push(p);
                                                                        }
                                                                  })
                                                          })
                                                    }else{
                                                          m.resultList = m.resultLists;
                                                    }
                                              } 
                                        })
                                 }
                        })
                    }
                    self.dimensionZoneLeftList = dimensionZoneLeftList;
                    localStorage.setItem('dimensionZoneLeftList',JSON.stringify(self.dimensionZoneLeftList));
            // }
            // else{
            //       let dimensionZoneLeftList = JSON.parse(localStorage.getItem("dimensionZoneLeftList")); 
            //       if(dimensionZoneLeftList != null && dimensionZoneLeftList.length > 0){
            //             dimensionZoneLeftList.forEach((m)=>{
            //                     if(m.dimensionLinkageVOS != null && m.dimensionLinkageVOS.length > 0){ 
            //                             m.dimensionLinkageVOS.forEach((n)=>{
            //                                   if(n.linkageDimensionGuid == dimensionGuid){ 
            //                                          m.resultList = m.resultLists; 
            //                                     //      m.resultLists.forEach((p)=>{
            //                                     //           if(p[da]){
            //                                     //                 m.resultList.push(p[da]);
            //                                     //           }
            //                                     //      })
            //                                   } 
            //                             })
            //                      }
            //             })
            //         }
            //         self.dimensionZoneLeftList = dimensionZoneLeftList;
            // }
        }, 
        //获取页面 数据集
        getDataSetData() {
              let self = this;  
                self.pageGuid = JSON.parse(localStorage.getItem("pageinfo")).pageGuid; //获取到报表页面guid
                self.api.postJson(`/${serverConfig.msReportConfigService}/dataset/get`,{'reportPageGuid':self.pageGuid}).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                           self.dataSetList = res.data.data.records;
                           if(self.dataSetList != null && self.dataSetList.length > 0){
                                self.dataSetListSh = true;
                           }else{
                                self.dataSetListSh = false;
                           }  
                       }else {
                          self.$message.error(res.data.msg);
                       } 
                }) 
        },
         // 获取排名
        getRankingDataList(pageLayoutGuid) {
              let self = this;   
                self.api.postJson(`/${serverConfig.msReportConfigService}/ranking-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                           self.rankingData = res.data.data; 
                           if(self.rankingData != null){
                              //   self.rankingListSh = true;
                                let mark = [0,];
                                for(var i = 1;i <= self.rankingData.maxValue;i++){
                                    if(i % 5 == 0){   
                                            mark.push(i);
                                    }
                                  } 
                                  let obj = {}
                                  mark.forEach(item=> {
                                      obj[item] = JSON.stringify(item);
                                  })
                                  self.marks = obj; 
                           }else{
                              //   self.rankingListSh = false;
                           }  
                       }else {
                          self.$message.error(res.data.msg);
                       } 
                }) 
        },
        queryAll(){
            let self = this;
            let dimensionZoneLeftList = JSON.parse(localStorage.getItem("dimensionZoneLeftList"));
            if(dimensionZoneLeftList != null && dimensionZoneLeftList.length > 0){
                  dimensionZoneLeftList.forEach((m)=>{  
                        m.resultList.forEach((n)=>{
                              if(n.showSh){
                                    self.dataListAll.push(n);
                              } 
                        }) 
                  })
            } 
            self.outParamList = [];
            if(self.aggregateListSh){
                  self.getAggregateList();   
            } 
            if(self.gridAllListSh){
                  self.getGridZoneList();
            }  
            if(self.analysisChartListSh){
                  self.getAnalysisChartList();
            }
        },
        seachQueryAll(){
            let self = this;
            let dimensionZoneLeftList = JSON.parse(localStorage.getItem("dimensionZoneLeftList"));
            if(dimensionZoneLeftList != null && dimensionZoneLeftList.length > 0){
                  dimensionZoneLeftList.forEach((m)=>{  
                        m.resultList.forEach((n)=>{
                              if(n.showSh){
                                    self.dataListAll.push(n);
                              } 
                        }) 
                  })
            } 
            // self.outParamList = [];
            if(self.aggregateListSh){
                  self.getAggregateSeachList();   
            } 
            if(self.gridAllListSh){
                  self.getGridZoneSeachList();
            }  
            if(self.analysisChartListSh){
                  self.getAnalysisChartSeachList();
            }
        },
        empty(){ 
            let self = this;   
            if(self.dimensionZoneLeftList != null && self.dimensionZoneLeftList.length > 0){
                  self.dimensionZoneLeftList.forEach((m)=>{   
                        m.resultList.forEach((n)=>{
                              n.showSh = false;
                        }) 
                        m.resultLists.forEach((y)=>{
                              y.showSh = false;
                        })
                        m.resultList = m.resultLists;
                  })
            } 
            localStorage.setItem('dimensionZoneLeftList',JSON.stringify(self.dimensionZoneLeftList)); 
            self.$refs.arrive.getDateYear();
        },
        // 获取汇总数据
        getAggregateList() {
              let self = this;   
              let pageLayoutGuid = ''; 
              let guidList= [];
              self.aggregateList = [];
              self.summaryResult = [];
              let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList")); 
                if(pageInfoList !=null && pageInfoList.length > 0){
                      pageInfoList.forEach((i)=>{
                            if(i.zoneLocation == 'CENTER' && i.zoneType == '3'){
                                    pageLayoutGuid = i.guid;   //获取页面布局   汇总的guid  
                            }
                      })
                }
                if(pageLayoutGuid == null || pageLayoutGuid == ''){
                      return;
                }
                self.api.postJson(`/${serverConfig.msReportConfigService}/aggregate-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                              if(res.data.data != null && res.data.data.length > 0){
                                    res.data.data.forEach((i)=>{  
                                          let item = {
                                                datasetGuid:i.datasetGuid,
                                                aggregateDataName:i.aggregateDataName,
                                                valueType:i.valueType
                                          }
                                          self.summaryResult.push(item);
                                          if(guidList.indexOf(i.datasetGuid) == -1){
                                                guidList.push(i.datasetGuid);
                                                self.aggregateList.push(i);
                                          }   
                                    }) 
                              }  
                              self.width.width = 100 / self.summaryResult.length +'%';
                              self.summaryAll = [];
                              if(self.aggregateList != null && self.aggregateList.length > 0){
                                    self.aggregateList.forEach((i)=>{ 
                                          setTimeout(function(){
                                                self.getGridDatasetSummaryResult(i,i.datasetGuid,i.dataSetVO,pageLayoutGuid);
                                          },1000);
                                    }) 
                                    // self.aggregateListSh = true;
                              }else{
                                    // self.aggregateListSh = false;
                              }  
                       }else {
                          self.$message.error(res.data.msg);
                       } 
                }) 
        }, 
        getAggregateSeachList() {
              let self = this;   
              let pageLayoutGuid = ''; 
              let guidList= [];
              self.aggregateList = [];
              self.summaryResult = [];
            //   self.outParamList = [];
              let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList")); 
                if(pageInfoList !=null && pageInfoList.length > 0){
                      pageInfoList.forEach((i)=>{
                            if(i.zoneLocation == 'CENTER' && i.zoneType == '3'){
                                    pageLayoutGuid = i.guid;   //获取页面布局   汇总的guid  
                            }
                      })
                }
                if(pageLayoutGuid == null || pageLayoutGuid == ''){
                      return;
                }
                self.api.postJson(`/${serverConfig.msReportConfigService}/aggregate-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                              if(res.data.data != null && res.data.data.length > 0){
                                    res.data.data.forEach((i)=>{  
                                          let item = {
                                                datasetGuid:i.datasetGuid,
                                                aggregateDataName:i.aggregateDataName,
                                                valueType:i.valueType
                                          }
                                          self.summaryResult.push(item);
                                          if(guidList.indexOf(i.datasetGuid) == -1){
                                                guidList.push(i.datasetGuid);
                                                self.aggregateList.push(i);
                                          }   
                                          // if(i.dataSetVO.paramItems != null && i.dataSetVO.paramItems != ''){
                                          //       i.dataSetVO.paramItems.forEach((j)=>{
                                          //             if(j.paramType == 'OUTSIDE'){
                                          //                   let param = {
                                          //                         name:j.name,
                                          //                         param:'',
                                          //                         data:j.data.substr(2,j.data.length-3)
                                          //                   }
                                          //                   self.outParamList.push(param);
                                          //                   console.log("外参",param);
                                          //             } 
                                          //       }) 
                                          // }
                                    }) 
                              }  
                              self.width.width = 100 / self.summaryResult.length +'%';
                              self.summaryAll = [];
                              if(self.aggregateList != null && self.aggregateList.length > 0){
                                    self.aggregateList.forEach((i)=>{ 
                                          setTimeout(function(){
                                                self.getGridDatasetSummaryResult(i,i.datasetGuid,i.dataSetVO,pageLayoutGuid);
                                          },1000);
                                    }) 
                                    // self.aggregateListSh = true;
                              }else{
                                    // self.aggregateListSh = false;
                              }  
                       }else {
                          self.$message.error(res.data.msg);
                       } 
                }) 
        }, 
      //   获取图表数据
        getAnalysisChartList() {
              let self = this;   
              let pageLayoutGuid = '';
              let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList")); 
                if(pageInfoList !=null && pageInfoList.length > 0){
                      pageInfoList.forEach((i)=>{
                            if(i.zoneLocation == 'CENTER' && i.zoneType == '4'){
                                    pageLayoutGuid = i.guid;   //获取页面布局   汇总的guid  
                            }
                      })
                }
                if(pageLayoutGuid == null || pageLayoutGuid == ''){
                      return;
                }
                self.barCharList = [];
                self.api.postJson(`/${serverConfig.msReportConfigService}/analysis-chart-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                           self.analysisChartList = res.data.data;
                           if(self.analysisChartList != null && self.analysisChartList.length > 0){ 
                                 self.analysisChartList.forEach((i,index)=>{
                                       let item = {
                                             id:i.analysisType + index,
                                             analysisChartName:i.analysisChartName,
                                             analysisType:i.analysisType,
                                             list:[]
                                       }
                                       self.barCharList.push(item); 
                                       setTimeout(function(){ 
                                          self.getCharDatasetResult(index,i,i.datasetGuid,i.dataSetVO,pageLayoutGuid);   
                                       },1000) 
                                 })
                           }
                           if(self.barCharList != null && self.barCharList.length > 0){
                                 setTimeout(function(){ 
                                          self.analysisChartListSh = true;
                                    },1500) 
                           }else{
                                self.analysisChartListSh = false;
                           }  
                       }else {
                          self.$message.error(res.data.msg);
                       } 
                }) 
        },
        //   获取图表数据
        getAnalysisChartSeachList() {
              let self = this;   
              let pageLayoutGuid = '';
              let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList")); 
                if(pageInfoList !=null && pageInfoList.length > 0){
                      pageInfoList.forEach((i)=>{
                            if(i.zoneLocation == 'CENTER' && i.zoneType == '4'){
                                    pageLayoutGuid = i.guid;   //获取页面布局   汇总的guid  
                            }
                      })
                }
                if(pageLayoutGuid == null || pageLayoutGuid == ''){
                      return;
                }
                self.barCharList = [];
                self.api.postJson(`/${serverConfig.msReportConfigService}/analysis-chart-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                           self.analysisChartList = res.data.data;
                           if(self.analysisChartList != null && self.analysisChartList.length > 0){ 
                                 self.analysisChartList.forEach((i,index)=>{
                                       let item = {
                                             id:i.analysisType + index,
                                             analysisChartName:i.analysisChartName,
                                             analysisType:i.analysisType,
                                             list:[]
                                       }
                                       self.barCharList.push(item);
                                       if(i.dataSetVO.paramItems != null && i.dataSetVO.paramItems != ''){
                                                i.dataSetVO.paramItems.forEach((j)=>{
                                                      if(j.paramType == 'OUTSIDE'){
                                                            let param = {
                                                                  name:j.name,
                                                                  param:'',
                                                                  data:j.data.substr(2,j.data.length-3)
                                                            }
                                                            self.outParamList.push(param);
                                                            console.log("外参",param);
                                                      } 
                                                }) 
                                          }
                                       setTimeout(function(){ 
                                          self.getCharDatasetResult(index,i,i.datasetGuid,i.dataSetVO,pageLayoutGuid);   
                                       },1000) 
                                 })
                           }
                           if(self.barCharList != null && self.barCharList.length > 0){
                                 setTimeout(function(){ 
                                          self.analysisChartListSh = true;
                                    },1500) 
                           }else{
                                self.analysisChartListSh = false;
                           }  
                       }else {
                          self.$message.error(res.data.msg);
                       } 
                }) 
        },
        // 获取表格数据
        getGridZoneList() {
              let self = this;   
              let pageLayoutGuid = '';
              
                  let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList")); 
                if(pageInfoList !=null && pageInfoList.length > 0){
                      pageInfoList.forEach((i)=>{
                            if(i.zoneLocation == 'CENTER' && i.zoneType == '5'){
                                    pageLayoutGuid = i.guid;   //获取页面布局   汇总的guid  
                            }
                      })
                } 
                if(pageLayoutGuid == null || pageLayoutGuid == ''){
                      return;
                }
                self.api.postJson(`/${serverConfig.msReportConfigService}/grid-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                              self.gridAllList = res.data.data;  
                              if(self.gridAllList != null && self.gridAllList.length > 0){
                                    self.tableAllResult = [];
                                    self.gridAllList.forEach((i)=>{
                                          let item = {
                                                datasetGuid:i.datasetGuid,
                                                title:i.gridName,
                                                tableHead:i.dataSetVO.fieldList,
                                                drillFieldList:i.gridDrillVOList,
                                                dataSetVO:i.dataSetVO,
                                                pageLayoutGuid:i.pageLayoutGuid,
                                                tableData:[], 
                                          }
                                          self.tableAllResult.push(item);
                                          if(i.dataSetVO.paramItems != null && i.dataSetVO.paramItems != ''){
                                                i.dataSetVO.paramItems.forEach((j)=>{
                                                      if(j.paramType == 'OUTSIDE'){
                                                            let param = {
                                                                  name:j.name,
                                                                  param:'',
                                                                  data:j.data.substr(2,j.data.length-3)
                                                            }
                                                            self.outParamList.push(param);
                                                            console.log("外参",param);
                                                      } 
                                                }) 
                                          }
                                    }) 
                                    self.getGridDatasetResult(self.gridAllList[0],self.gridAllList[0].datasetGuid,self.gridAllList[0].dataSetVO,pageLayoutGuid);   
                                    // self.aggregateListSh = true; 
                              }else{
                                    // self.aggregateListSh = false;
                              }  
                       }else {
                          self.$message.error(res.data.msg);
                       } 
                }) 
        },
        getGridZoneSeachList() {
              let self = this;   
              let pageLayoutGuid = '';
              
                  let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList")); 
                if(pageInfoList !=null && pageInfoList.length > 0){
                      pageInfoList.forEach((i)=>{
                            if(i.zoneLocation == 'CENTER' && i.zoneType == '5'){
                                    pageLayoutGuid = i.guid;   //获取页面布局   汇总的guid  
                            }
                      })
                } 
                if(pageLayoutGuid == null || pageLayoutGuid == ''){
                      return;
                }
                self.api.postJson(`/${serverConfig.msReportConfigService}/grid-zone/get?pageLayoutGuid=`+pageLayoutGuid).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                              self.gridAllList = res.data.data;  
                              if(self.gridAllList != null && self.gridAllList.length > 0){
                                    self.tableAllResult = [];
                                    self.gridAllList.forEach((i)=>{
                                          let item = {
                                                datasetGuid:i.datasetGuid,
                                                title:i.gridName,
                                                tableHead:i.dataSetVO.fieldList,
                                                drillFieldList:i.gridDrillVOList,
                                                dataSetVO:i.dataSetVO,
                                                tableData:[], 
                                          }
                                          self.tableAllResult.push(item);
                                          // if(i.dataSetVO.paramItems != null && i.dataSetVO.paramItems != ''){
                                          //       i.dataSetVO.paramItems.forEach((j)=>{
                                          //             if(j.paramType == 'OUTSIDE'){
                                          //                   let param = {
                                          //                         name:j.name,
                                          //                         param:'',
                                          //                         data:j.data.substr(2,j.data.length-3)
                                          //                   }
                                          //                   self.outParamList.push(param);
                                          //                   console.log("外参",param);
                                          //             } 
                                          //       }) 
                                          // }
                                    }) 
                                    self.getGridDatasetResult(self.gridAllList[0],self.gridAllList[0].datasetGuid,self.gridAllList[0].dataSetVO,pageLayoutGuid);   
                                    // self.aggregateListSh = true; 
                              }else{
                                    // self.aggregateListSh = false;
                              }  
                       }else {
                          self.$message.error(res.data.msg);
                       } 
                }) 
        },
        //钻取详情
        toDetail(drilllist,row){ 
            let self = this; 
            let paramList = [];
            let paramDrillData = [];
            if(drilllist.drillFieldList != null && drilllist.drillFieldList != ''){
                  let datasetGuid = drilllist.drillFieldList[0].datasetGuid;
                  let pageLayoutGuid = drilllist.pageLayoutGuid; 
                  console.log(pageLayoutGuid);
                  if(drilllist.drillFieldList[0].drillFieldList != null && drilllist.drillFieldList[0].drillFieldList.length > 0){  
                        if(drilllist.drillFieldList[0].dataSetVO.paramItems !=null && drilllist.drillFieldList[0].dataSetVO.paramItems.length > 0){
                              // console.log(dataSetList.paramItems);
                              drilllist.drillFieldList[0].dataSetVO.paramItems.forEach((j)=>{
                                    if(j.data != null && j.data != ''){ 
                                          if(j.data.substr(0,2) == '@{' && j.data.substr(-1,5) == '}'){
                                                let item = {
                                                   name:j.name,
                                                   value:j.data.substr(2,j.data.length-3)
                                                }
                                                paramList.push(item);
                                                
                                          }
                                    }
                              })
                              console.log("可以查",paramList);
                        }  
                        paramList.forEach((i)=>{ 
                              paramDrillData = paramDrillData +'"'+ i.value +'"'+':'+'"'+row[i.name] +'"'+',' ; 
                        })
                        let paramDatas =JSON.parse('{'+paramDrillData.substr(0,paramDrillData.length-1)+'}'); 
                        self.page.datasetGuid = datasetGuid;
                        self.page.pageLayoutGuid = pageLayoutGuid;
                        self.page.paramData = paramDatas;  
                        //获取表格数据
                        self.getDatasetRresult(); 
                  }
                   
            }
        }, 
        commonAlgorithm(dataSetList){
            let self = this;
            let haveList = [];
            let paramList = [];
            let newArrAll = [];
            let dimensionZoneLeftList = JSON.parse(localStorage.getItem("dimensionZoneLeftList"));
            let dimensionZoneTopList = JSON.parse(localStorage.getItem("dimensionZoneTopList"));
            newArrAll = dimensionZoneTopList;
            if(dimensionZoneLeftList != null && dimensionZoneLeftList != ''){
                  newArrAll = dimensionZoneTopList.concat(dimensionZoneLeftList);
            }
            
            console.log("参数的",self.dataListAll,"页面维度结果",newArrAll,"数据集的",dataSetList);
            if(self.dataListAll != null && self.dataListAll.length > 0){
                  self.dataListAll.forEach((h)=>{
                        if(newArrAll != null && newArrAll.length > 0){
                              newArrAll.forEach((i)=>{
                                    if(i != null){
                                          if(i.resultList != null && i.resultList.length > 0){
                                                i.resultList.forEach((j)=>{
                                                      // console.log(h,j[i.useFieldList[0]]);
                                                      if(h[i.useFieldList[0]] == j[i.useFieldList[0]]){  //参数目前只能是一个 MONTH
                                                            if(haveList.indexOf(j)==-1){
                                                                  haveList.push(j);
                                                            }    
                                                      }
                                                })
                                          }
                                    } 
                              })
                        }
                  })
            }
            console.log("有数据集查询参数的值1",haveList);
            // 过滤是否存在查询参数的数据集 
            if(dataSetList.paramItems !=null && dataSetList.paramItems.length > 0){
                  // console.log(dataSetList.paramItems);
                  dataSetList.paramItems.forEach((j)=>{
                        if(j.data != null && j.data != ''){ 
                              if(j.data.substr(0,2) == '@{' && j.data.substr(-1,5) == '}'){
                                    paramList.push(j.data.substr(2,j.data.length-3));
                                    // console.log("可以查"+dataSetList.datasetName,i.guid,j.data.substr(2,j.data.length-2));
                              }
                        }
                  })
            }  
            // paramList = ["MONTH"]; //临时数组，后期要改
            console.log("有数据集查询参数的值2",paramList);
            let paramData = ''; 
            if(paramList != null && paramList.length > 0){
                  paramList.forEach((m)=>{
                        if(haveList != null && haveList.length > 0){
                              let nList = []; 
                              haveList.forEach((n)=>{
                                    if(n[m] != null && n[m] != ''){ 
                                          nList.push("'"+n[m]+"'");
                                          paramData = paramData +'"'+ m +'"'+':'+'"'+nList +'"'+',' ; 
                                    }
                              })
                        }
                        // paramData = paramData +'"'+ m +'"'+':'+'"'+nList +'"'+',' ;  
                  })
            }
            if(self.outParamList != null && self.outParamList.length > 0){
                  self.outParamList.forEach((i)=>{
                        paramData = paramData + '"'+i.data+'":"'+i.param +'",'
                  })
            }
            console.log('外部参数',paramData); 
            // console.log(paramData);
            // console.log('{'+paramData.substr(0,paramData.length-1)+'}');
             let paramDatas =JSON.parse('{'+paramData.substr(0,paramData.length-1)+'}'); //paramData.substr(0,paramData.length-1);
            console.log('查询最终结果',paramDatas);
            return paramDatas;
        },
      //   获取汇总
        getGridDatasetSummaryResult(gridList,datasetGuid,dataSetList,pageLayoutGuid){
            let self = this; 
            let paramDatas = self.commonAlgorithm(dataSetList);
            self.gridList = gridList;
            self.page.datasetGuid = datasetGuid;
            self.page.pageLayoutGuid = pageLayoutGuid;
            self.page.paramData = paramDatas; 
            //获取汇总 
            self.getDatasetSummaryRresult();  
        }, 
      //   图表数据汇总
        getCharDatasetResult(index,gridList,datasetGuid,dataSetList,pageLayoutGuid){
            let self = this; 
            let paramDatas = self.commonAlgorithm(dataSetList);
            self.gridList = gridList; 
            self.page.datasetGuid = datasetGuid;
            self.page.pageLayoutGuid = pageLayoutGuid;
            self.page.paramData = paramDatas;  
            //图表数据汇总
            self.getCharDatasetRresult(index); 
        }, 
      //   获取表格
        getGridDatasetResult(gridList,datasetGuid,dataSetList,pageLayoutGuid){
            let self = this; 
            let paramDatas = self.commonAlgorithm(dataSetList);
            self.gridList = gridList; 
            self.page.datasetGuid = datasetGuid;
            self.page.pageLayoutGuid = pageLayoutGuid;
            self.page.paramData = paramDatas;  
            //获取表格数据
            self.getDatasetRresult(); 
        }, 
        handleClick(tab, event) {
            let self = this;
            self.page.pageIndex = 1;
            let paramDatas = '';
            self.tableAllResult.forEach((i,index)=>{
                  if(tab.label == i.title){
                        self.page.datasetGuid = i.datasetGuid;
                        // console.log('ddddddd',self.tableAllResult,i.dataSetVO);
                        paramDatas = self.commonAlgorithm(i.dataSetVO);
                  }
            })
            self.page.pageIndex = 1;
            self.page.totalRows = 0;
            self.page.paramData = paramDatas;
            self.getDatasetRresultPage(); 
        },
        handleSizeChange(val) {
            let self = this;
              self.page.pageSize = val;
              self.getDatasetRresultPage();
        },
        handleCurrentChange(val) { 
            let self = this;  
            self.page.pageIndex = val;
            self.getDatasetRresultPage(); 
            
            //   self.page.pageIndex = val;
            //   this.getData();
        },
        getResults(dateDatasList){
            let self = this; 
            self.dataListAll = dateDatasList;   
        }, 
        //导出数据集
        exportDatasetReport(){
            let self = this; 
            // console.log(self.page);
            self.api.postJson(`/${serverConfig.msReportConfigService}/dataset/data/export-dataset-report`,{'datasetGuid':self.page.datasetGuid,'pageIndex':1,'pageSize':-1,'pageLayoutGuid':self.page.pageLayoutGuid,'paramData':self.page.paramData}).then(res=>{ 
                  if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){  
                         self.reportJx(res.data.data.colNames,res.data.data.datas,res.data.data.sheetName,res.data.data.fileNam);
                  }else {
                        self.$message.error(res.data.msg);
                  } 
            })
        },
        reportJx(colNames,datas,sheetName,fileNam){
            let self = this; 
          self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`,{'colNames':colNames,'datas':datas,'sheetName':sheetName,'fileNam':fileNam})
          .then(res => {  
             let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
              let fileName = fileNam;
              let objectUrl = URL.createObjectURL(blob);
              const link = document.createElement('a')
              link.download = fileName;
              link.href = objectUrl;
              link.click();
          });
      },
         //获取表格数据
        getDatasetRresultPage(){
            let self = this; 
            self.api.postJson(`/${serverConfig.msReportConfigService}/dataset/get-dataset-result`,self.page).then(res=>{ 
                  if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){  
                        self.tableAllResult.forEach((i,index)=>{
                              if(self.page.datasetGuid == i.datasetGuid){
                                    let data = res.data.data.records;  
                                    if(data != null){
                                          data.forEach((item)=>{ 
                                                for(let da in item){ 
                                                      if(da.indexOf('元') != -1){
                                                            item[da] = self.numFmt(self.numDigit(item[da]));  
                                                      } 
                                                }  
                                          }) 
                                    }
                                    self.tableAllResult[index].tableData = data;
                                    self.page.totalPage = res.data.data.totalPages;
                                    self.page.totalRows = res.data.data.totalRows;
                              }
                        })
                  }else {
                        self.$message.error(res.data.msg);
                  } 
            })
        },
        numDigit(val){ 
            if(val=='' || val ==null) {
                  return 0;
            }
            val = val.toString().replace(/\$|\,/g,'');
            if(isNaN(val)) {
            val = "0";  
            } 
            let sign = (val == (val = Math.abs(val)));
            val = Math.floor(val*100+0.50000000001);
            let cents = val%100;
            val = Math.floor(val/100).toString();
            if(cents<10) {
            cents = "0" + cents
            }
            for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
            val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
            }

            return (((sign)?'':'-') + val + '.' + cents);
      },
        numFmt(val){ 
                  if(val=='' || val ==null) {
                        return 0;
                  }
                  if(!/^(\+|-)?(\d+)(\.\d+)?$/.test(val)) {
                        return val;
                  }
                  let a = RegExp.$1,
                        b = RegExp.$2,
                        c = RegExp.$3;
                  let re = new RegExp("(\\d)(\\d{3})(,|$)");
                  while(re.test(b)) b = b.replace(re, "$1,$2$3");
                  return a + "" + b + "" + c;
        },
        //获取表格数据
        getDatasetRresult(){
            let self = this;  
            self.api.postJson(`/${serverConfig.msReportConfigService}/dataset/get-dataset-result`,self.page).then(res=>{ 
                  if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                        let data = res.data.data.records;
                        if(data != null){ 
                              data.forEach((item)=>{ 
                                          for(let da in item){ 
                                                if(da.indexOf('元') != -1){
                                                      item[da] = self.numFmt(self.numDigit(item[da]));  
                                                } 
                                          }  
                                    }) 
                                    // self.tableAllResult[index].tableData = data;
                              self.tableAllResult[0].tableData = data;
                        } 
                        if(self.tableAllResult != null && self.tableAllResult.length > 0){
                              self.activeName = self.tableAllResult[0].title;
                              self.page.datasetGuid = self.tableAllResult[0].datasetGuid;
                              self.page.totalPage = res.data.data.totalPages;
                              self.page.totalRows = res.data.data.totalRows;
                        }  
                        console.log(self.tableAllResult);
                  }else {
                        self.$message.error(res.data.msg);
                  } 
            }) 
        },
        //获取图表数据
        getCharDatasetRresult(idx){
            let self = this;  
            self.page.pageIndex = 1;
            // self.page.pageSize = -1;
            self.page.analysisType = self.gridList.analysisType;
            self.api.postJson(`/${serverConfig.msReportConfigService}/dataset/get-chart-dataset-result`,self.page).then(res=>{ 
                  if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                        self.barCharList[idx].list = res.data.data;   
                        setTimeout(() => {
                              self.$refs.bar.getCharList(self.barCharList);
                        }, 1000); 
                  }else {
                        self.$message.error(res.data.msg);
                  } 
            }) 
        },
        //获取汇总数据
        getDatasetSummaryRresult(){
            let self = this;  
            self.api.postJson(`/${serverConfig.msReportConfigService}/dataset/get-dataset-result`,self.page).then(res=>{ 
                  if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                        let data = res.data.data.records[0];
                        for(var key in data){   
                              var item = {
                                    key:key,
                                    sum:data[key]
                              }
                              self.summaryAll.push(item);
                        }
                        console.log('汇总数据',self.summaryAll);
                        
                        if(self.summaryAll != null && self.summaryAll.length > 0){
                              self.summaryAll.forEach((i)=>{
                                    self.summaryResult.forEach((j)=>{
                                          if(i.key == j.aggregateDataName){
                                                j.sum = i.sum;
                                          }
                                    })  
                              })
                        }  
                        self.summaryResults = self.summaryResult;
                        // self.aggregateListSh = true;
                        console.log('汇总数据1',self.summaryResults);
                        // summaryAll 
                  }else {
                        self.$message.error(res.data.msg);
                  } 
            }) 
        },
        //获取图表数据
        getChartDatasetRresult(datasetGuid,pageLayoutGuid,paramDatas){
            let self = this;
            self.api.postJson(`/${serverConfig.msReportConfigService}/dataset/get-chart-dataset-result?datasetGuid=`+ datasetGuid +'&pageLayoutGuid='+pageLayoutGuid,paramDatas).then(res=>{ 
                  if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                        let data = res.data.data; 
                        // console.log(data[0].split('{')[1]);
                        // console.log(data[1].split(']')[0]);
                        // self.chartDatasetResult.push(item); 
                        
                  }else {
                  self.$message.error(res.data.msg);
                  } 
            })
        }, 
        //添加报表页面
        getDimensionName(){
            let self = this;
            if(self.pageName != this.oldPageName || self.pageUrl != this.oldpageUrl){
              if(self.pageGuid){
                   self.api.put(`/${serverConfig.msReportConfigService}/reportpage/update`,{'guid':self.pageGuid,'pageName':self.pageName,'pageUrl':self.pageUrl}).then(res=>{
                        self.oldPageName = self.pageName;
                        self.oldpageUrl = self.pageUrl;
                         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                              let item = {
                                    pageGuid:self.pageGuid,
                                    pageName:self.pageName,
                                    pageUrl:self.pageUrl
                              }
                              localStorage.setItem('pageinfo',JSON.stringify(item)); //缓存报表页面信息
                         }else {
                          self.$message.error(res.data.msg);
                         } 
                   }) 
              }else{
                  self.api.postJson(`/${serverConfig.msReportConfigService}/reportpage/add`,{'pageName':self.pageName,'pageUrl':self.pageUrl}).then(res=>{
                        self.oldPageName = self.pageName;
                        self.oldpageUrl = self.pageUrl;
                         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                                   self.pageGuid = res.data.data;
                              let item = {
                                    pageGuid:res.data.data,
                                    pageName:self.pageName,
                                    pageUrl:self.pageUrl
                              }
                              localStorage.setItem('pageinfo',JSON.stringify(item));  //缓存报表页面信息
                         }else {
                          self.$message.error(res.data.msg);
                         } 
                  }) 
              } 
            } 
        },
        //维度一区 显示隐藏 修改
        updatePageLayouthide(){
          let self = this;
          let pageLayoutGuid = '';
            let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList"));
            for (var i = 0; i < pageInfoList.length; i++) {
                if(pageInfoList[i].zoneLocation == 'TOP' && pageInfoList[i].zoneType == '1'){
                          pageLayoutGuid = pageInfoList[i].guid; //获取页面布局   维度一区的guid
                  }else{
                          // self.$message.error("请先添加维度！");
                          return
                  }
            } 
            let hideFlag = '';
            if(self.dimension1 == 1){
                   hideFlag = true;
            }else{
                   hideFlag = false;
            } 
              self.api.put(`/${serverConfig.msReportConfigService}/reportpage/update-page-layout-hide?hideFlag=`+hideFlag+'&pageLayoutGuid='+pageLayoutGuid).then(res=>{ 
                         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                                self.getPageLayoutData();
                         }else {
                          self.$message.error(res.data.msg);
                         } 
                   }) 
        },
        //维度二区 显示隐藏 修改
        updatePageLayoutLefthide(){
            let self = this;
            let pageLayoutGuid = '';
            let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList"));
            for (var i = 0; i < pageInfoList.length; i++) {
              console.log(pageInfoList[i].zoneLocation == 'LEFT');
                if(pageInfoList[i].zoneLocation == 'LEFT'){
                          pageLayoutGuid = pageInfoList[i].guid; //获取页面布局   维度一区的guid
                  }else{
                          // self.$message.error("请先添加维度1！");
                          return
                  }
            } 
            let hideFlag = '';
            if(self.dimension2 == 1){
                   hideFlag = true;
            }else{
                   hideFlag = false;
            } 
              self.api.put(`/${serverConfig.msReportConfigService}/reportpage/update-page-layout-hide?hideFlag=`+hideFlag+'&pageLayoutGuid='+pageLayoutGuid).then(res=>{ 
                         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                                self.getPageLayoutData();
                         }else {
                          self.$message.error(res.data.msg);
                         } 
                   }) 
        },
        //汇总区 显示隐藏 修改
        updatePageLayoutCenterAggregatehide(){
            let self = this;
            let pageLayoutGuid = '';
            let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList"));
            for (var i = 0; i < pageInfoList.length; i++) {
                if(pageInfoList[i].zoneLocation+pageInfoList[i].zoneType == 'CENTER3'){
                          pageLayoutGuid = pageInfoList[i].guid; //获取页面布局   维度一区的guid
                  }
            } 
            let hideFlag = '';
            if(self.dimension3 == 1){
                   hideFlag = true;
            }else{
                   hideFlag = false;
            } 
              self.api.put(`/${serverConfig.msReportConfigService}/reportpage/update-page-layout-hide?hideFlag=`+hideFlag+'&pageLayoutGuid='+pageLayoutGuid).then(res=>{ 
                         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                                self.getPageLayoutData();
                         }else {
                          self.$message.error(res.data.msg);
                         } 
                   }) 
        },
        //排名 显示隐藏 修改
        updatePageLayoutCenterrRankinghide(){
            let self = this;
            let pageLayoutGuid = '';
            let  pageInfoList = JSON.parse(localStorage.getItem("pageLayoutList"));
            for (var i = 0; i < pageInfoList.length; i++) {
                if(pageInfoList[i].zoneLocation+pageInfoList[i].zoneType == 'CENTER4'){
                          pageLayoutGuid = pageInfoList[i].guid; //获取页面布局   维度一区的guid
                  }
            } 
            let hideFlag = '';
            if(self.dimension4 == 1){
                   hideFlag = true;
            }else{
                   hideFlag = false;
            } 
              self.api.put(`/${serverConfig.msReportConfigService}/reportpage/update-page-layout-hide?hideFlag=`+hideFlag+'&pageLayoutGuid='+pageLayoutGuid).then(res=>{ 
                         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                                self.getPageLayoutData();
                         }else {
                          self.$message.error(res.data.msg);
                         } 
                   }) 
        },


  },
};
</script>
<style  scoped>
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
/deep/ .el-tabs--border-card {
    background: #FFF;
    border: 1px solid #DCDFE6;
    -webkit-box-shadow: none;
    box-shadow: none;
}
/deep/ .el-input__inner {
      border:0;
      font-size: 20px;
      font-weight: bold; 
}
</style>